import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { searchTextState } from '../../redux/cities'

class SearchField extends Component {

  handleOnKeyUp = () => {
    this.props.search(this.refs.searchInput.value)
    this.props.dispatch(searchTextState(this.refs.searchInput.value))
    this.props.callback()
  }

  componentDidMount() {
    if (this.props.cities && this.props.cities.previousSearchText) {
      this.setValue(this.props.cities.previousSearchText)
    } else {
      this.setValue("")
    }
  }

  setValue(value) {
    ReactDOM.findDOMNode(this.refs.searchInput).value = value
    this.props.search(value)
  }

  render() {
    return (
      <input
        ref='searchInput'
        className='form-control'
        type='text'
        defaultValue={this.props.defaultValue}
        placeholder="Enter City details..."
        onKeyUp={this.handleOnKeyUp} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    cities: state.cities
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(SearchField)


// WEBPACK FOOTER //
// ./src/modules/Cities/Components/TableCustomComponents/SearchField.js